// Package Imports
import React, {useLayoutEffect} from "react";

// Internal Imports
import AccountDetailsForm from "./signupSteps/AccountDetailsForm";
import CompanyDetailsForm from "./signupSteps/CompanyDetailsForm";
import AccountTypeForm from "./signupSteps/AccountTypeForm";
import { useAuthStore } from "../../store";
import mixpanelService from "../../services/mixpanel";

const SignUpForm = (props) => {
  // eslint-disable-next-line
  const signupState = useAuthStore((s) => s.signUpInputs);
  const setSignUpState = useAuthStore((s) => s.setSignUpInputs);
  const stepState = useAuthStore((s) => s.authStep);
  const setStepState = useAuthStore((s) => s.setAuthStep);

  // SIDE-EFFECT - Mixpanel Tracking
  useLayoutEffect(() => {
    mixpanelService.track("App.SignUp.Form", {signupState});
  },[]);

  // Route user to next step in Sign-Up form
  const nextStep = () => {
    setStepState(stepState + 1);
  };

  // Route user to next step in Sign-Up form
  const prevStep = () => {
    setStepState(stepState - 1);
  };

  // Update form state based on multi-step user input
  const formChangeHandler = async (formData, formKey) => {
    // if (formKey === "account") {
    //   setSignUpState(formData);
    // } else if (formKey === "company") {
    //   setSignUpState((prevState)  => ({
    //     ...prevState,
    //     formData,
    //   }));
    // } else if (formKey === "user") {
    //   setSignUpState((prevState)  => ({
    //     ...prevState,
    //     formData,
    //   })); 
    // } else {
    //   console.log("ERROR: Invalid Key Supplied");
    // }
    setSignUpState({
      ...signupState,
      ...formData
    });
  };

  const renderForms = () => {
    let step = stepState;

    switch (step) {
      case 1:
        window.localStorage.clear();
        return (
          <AccountDetailsForm
            nextStep={nextStep}
            formChangeHandler={formChangeHandler}
          />
        );
      case 2:
        return (
          <CompanyDetailsForm
            nextStep={nextStep}
            prevStep={prevStep}
            formChangeHandler={formChangeHandler}
          />
        );
      case 3:
        return (
          <AccountTypeForm
            prevStep={prevStep}
            setStepState={setStepState}
            formChangeHandler={formChangeHandler}
          />
        );
      default:
        window.localStorage.clear();
        return (
          <AccountDetailsForm
            nextStep={nextStep}
            formChangeHandler={formChangeHandler}
          />
        );
    }
  };

  return <>{renderForms()}</>;
};

export default SignUpForm;
